import { useState, useEffect } from 'react';
import logo from '../assets/images/logo.png';

const MIN_MS = 2000;

const LoadingScreen = () => {
    const [phase, setPhase] = useState('visible');

useEffect(() => {
        const start = Date.now();
        const begin = () => {
            const wait = Math.max(0, MIN_MS - (Date.now() - start));
            setTimeout(() => {
                setPhase('exiting');
                setTimeout(() => setPhase('gone'), 750);
            }, wait);
        };
        if (document.readyState === 'complete') {
            begin();
        } else {
            window.addEventListener('load', begin, { once: true });
            return () => window.removeEventListener('load', begin);
        }
    }, []);

    if (phase === 'gone') return null;

    return (
        <div
            className={`loading-screen${phase === 'exiting' ? ' loading-screen--exiting' : ''}`}
            aria-label="Loading ChArtIt"
            aria-live="polite"
        >
            <div className="loading-panel loading-panel--top" aria-hidden="true" />
            <div className="loading-panel loading-panel--bottom" aria-hidden="true" />
<div className="loading-content">
                <img src={logo} alt="ChArtIt" className="loading-logo" />
                <div
                    className="loading-bar-wrap"
                    role="progressbar"
                    aria-label="Loading"
                >
                    <div className="loading-bar-fill" />
                </div>
                <p className="loading-label">Initializing</p>
            </div>
        </div>
    );
};

export default LoadingScreen;
